import {
  STEP_DESTINATION_HELP_1,
  STEP_DESTINATION_HELP_2,
  STEP_DESTINATION_HELP_3,
  STEP_DESTINATION_HELP_4,
  STEP_DESTINATION_HELP_5,
  STEP_DESTINATION_HELP_RESULT,
  STEP_DESTINATION_HELP_RESULT_LOADING,
  STEP_DESTINATION_METHODOLOGY_SCREEN,
} from "../../class/transferDetails";
import HenryIntroScreen from "./screens/HenryIntro";
import useHenryQuestionniare from "./useHenryQuestionnaire";
import HenryQuestionniareResult from "./screens/HenryQuestionniareResult";
import HenryQuestionnaireOne from "./screens/HenryQuestionnaireOne";
import HenryQuestionnaireTwo from "./screens/HenryQuestionnaireTwo";
import HenryQuestionnaireThree from "./screens/HenryQuestionnaireThree";
import HenryQuestionnaireFour from "./screens/HenryQuestionnaireFour";
import HenryQuestionnaireFive from "./screens/HenryQuestionnaireFive";
import HenryQuestionnaireSix from "./screens/HenryQuestionnaireSix";
import HenryQuestionnaireLoading from "./screens/HenryQuestionnaireLoading";
import MethodologyScreen from "./screens/MethodologyScreen";

const HenryQuestionnaireScreen = () => {
  const props = useHenryQuestionniare();
  const { currentStep, currentScreen } = props;
  if (currentScreen === STEP_DESTINATION_METHODOLOGY_SCREEN) {
    return <MethodologyScreen {...props} />;
  }
  if (currentScreen === STEP_DESTINATION_HELP_RESULT_LOADING) {
    return <HenryQuestionnaireLoading {...props} />;
  }
  if (currentScreen === STEP_DESTINATION_HELP_RESULT) {
    return <HenryQuestionniareResult {...props} />;
  }
  if (currentStep === 0) {
    return <HenryIntroScreen {...props} />;
  }
  if (currentScreen === STEP_DESTINATION_HELP_1) {
    return <HenryQuestionnaireOne {...props} />;
  }

  if (currentScreen === STEP_DESTINATION_HELP_2) {
    return <HenryQuestionnaireTwo {...props} />;
  }
  if (currentScreen === STEP_DESTINATION_HELP_3) {
    return <HenryQuestionnaireThree {...props} />;
  }
  if (currentScreen === STEP_DESTINATION_HELP_4) {
    return <HenryQuestionnaireFour {...props} />;
  }

  if (currentScreen === STEP_DESTINATION_HELP_5) {
    return <HenryQuestionnaireFive {...props} />;
  }
  if (currentStep === 6) {
    return <HenryQuestionnaireSix {...props} />;
  }
  return <></>;
};

export default HenryQuestionnaireScreen;
